<template>
  <main class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Content Details</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col comp-grid">
            <div>
              <div style="min-height: 100px">
                <template v-if="pageReady">
                  <div class="grid">
                    <div class="col-12">
                      <div class="grid align-items-center">
                        <div class="col">Category:</div>
                        <div class="col font-bold">
                          {{ $utils.capitalize(item.feed_type) }}
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Author:</div>
                        <div class="col font-bold">
                          {{ item.author }}
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Title:</div>
                        <div class="col font-bold">
                          {{ item.title }}
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Message:</div>
                        <div class="col font-bold">
                          {{ item.message }}
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Attached Files:</div>
                        <div class="col font-bold">
                          <image-viewer
                            image-size="medium"
                            image-preview-size=""
                            :src="item.media"
                            width="30px"
                            height="30px"
                            :num-display="10"
                          >
                          </image-viewer>
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Target Region(s):</div>
                        <div class="col font-bold">
                          {{ item.target_region }}
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Target District(s):</div>
                        <div class="col font-bold">
                          {{ item.target_district }}
                        </div>
                      </div>
                      <hr />
                      <div class="grid align-items-center">
                        <div class="col">Date Sent:</div>
                        <div class="col font-bold">
                          {{ $utils.humanDatetime(item.date_created) }}
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                  <div class="flex justify-content-start">
                    <Menubar
                      class="p-0"
                      ref="actionMenu"
                      :model="getActionMenuModel(item)"
                    />
                  </div>
                </template>
                <template v-if="loading">
                  <div>
                    <table class="p-datatable-table w-full">
                      <tbody>
                        <tr v-for="n in 5" :key="n">
                          <td class="text-left" style="width: 100%">
                            <Skeleton height="2rem" class="m-2" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
import { toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useViewPage } from "@/composables/viewpage.js";
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "feed_id",
  },
  pageName: {
    type: String,
    default: "feeds",
  },
  routeName: {
    type: String,
    default: "feedsview",
  },
  apiPath: {
    type: String,
    default: "feeds/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const page = useViewPage(props); // page hook
const { item, loading, pageReady } = toRefs(page.state);
const { apiUrl, currentRecord } = page.computedProps;
const { load, deleteItem, exportPage, moveToNextRecord, moveToPreviousRecord } =
  page.methods;
function getActionMenuModel(data) {
  return [];
}
onMounted(() => {
  const pageTitle = "Content Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
